"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Paper_styles_1 = __importDefault(require("./Paper.styles"));
function Paper(_a) {
    var className = _a.className, children = _a.children, _b = _a.padding, padding = _b === void 0 ? 0 : _b, _c = _a.radius, radius = _c === void 0 ? 'sm' : _c, shadow = _a.shadow, themeOverride = _a.themeOverride, elementRef = _a.elementRef, others = __rest(_a, ["className", "children", "padding", "radius", "shadow", "themeOverride", "elementRef"]);
    var classes = Paper_styles_1.default({ radius: radius, shadow: shadow, padding: padding, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.paper, className), ref: elementRef }, others), children));
}
exports.Paper = Paper;
Paper.displayName = '@mantine/core/Paper';
